/* eslint-disable max-len */

export default {
  "dr-now-doctor-sign-up": "Registro de médico",
  "dr-now-doctor-sign-up-welcome-message": "¡Le damos la bienvenida a Dr. Now!",
  "dr-now-doctor-sign-up-welcome-please-fill-your-data": "Por favor, complete el siguiente formulario con sus datos para hacer el registro de su solicitud.",
  "dr-now-doctor-sign-up-names": "Nombres",
  "dr-now-doctor-sign-up-names-placeholder": "Ingresa tus nombres",
  "dr-now-doctor-sign-up-enter-two-or-more-names": "Escriba todos sus nombres",
  "dr-now-doctor-sign-up-first-surname": "Primer apellido",
  "dr-now-doctor-sign-up-surname-placeholder": "Ingresa tu apellido",
  "dr-now-doctor-sign-up-enter-your-first-surname": "Escriba su primer apellido",
  "dr-now-doctor-sign-up-second-surname": "Segundo apellido",
  "dr-now-doctor-sign-up-enter-your-second-surname": "Escriba su segundo apellido",
  "dr-now-doctor-sign-up-email": "Correo electrónico",
  "dr-now-doctor-sign-up-email-placeholder": "Ingresa tu correo",
  "dr-now-doctor-sign-up-enter-your-work-email": "Escriba su correo electrónico profesional",
  "dr-now-doctor-sign-up-country-code": "Código",
  "dr-now-doctor-sign-up-country": "País",
  "dr-now-doctor-sign-up-phone-number": "Teléfono",
  "dr-now-doctor-sign-up-phone-number-placeholder": "Ingresa tu número celular",
  "dr-now-doctor-sign-up-enter-your-phone-number": "Número de contacto",
  "dr-now-doctor-sign-up-password": "Contraseña",
  "dr-now-doctor-sign-up-password-placeholder": "Ingresa una contraseña segura",
  "dr-now-doctor-sign-up-enter-a-safe-password-msg": "Para garantizar la seguridad de su cuenta, cree una contraseña",
  "dr-now-doctor-sign-up-at-least-eight-characters": "Mínimo de 8 caracteres",
  "dr-now-doctor-sign-up-at-least-one-capital-letter": "Al menos una mayúscula",
  "dr-now-doctor-sign-up-at-least-one-number": "Al menos un número",
  "dr-now-doctor-sign-up-at-least-one-special-character": "Al menos un carácter especial",
  "dr-now-doctor-sign-up-password-confirmation": "Confirmar contraseña",
  "dr-now-doctor-sign-up-password-confirmation-placeholder": "Ingresa de nuevo la contraseña",
  "dr-now-doctor-sign-up-password-confirmation-msg": "Verifique que su contraseña coincida",
  "dr-now-doctor-sign-up-health-professional-disclaimer-agree": "Al aceptar está opción confirmo que soy profesional de la salud",
  "dr-now-doctor-sign-up-read-and-accept": "He leído y acepto",
  "dr-now-doctor-sign-up-terms-and-conditions": "Términos y condiciones, Política de Privacidad",
  "dr-now-doctor-sign-up-marketing-notifications-agree": "Acepto el envío de notificaciones de marketing",
  "dr-now-doctor-sign-up-optional": "opcional",
  "dr-now-doctor-sign-up-previous-fields-are-mandatory": "Estos campos son obligatorios",
  "dr-now-doctor-sign-up-continue": "Registrarme",
  "dr-now-doctor-sign-up-accept": "Aceptar",
  "dr-now-doctor-sign-up-field-required": "Campo requerido",
  "dr-now-doctor-sign-up-invalid-email": "Correo electrónico inválido",
  "dr-now-doctor-sign-up-invalid-phone-number": "Teléfono inválido",
  "dr-now-doctor-sign-up-invalid-characters": "Caracteres inválidos",
  "dr-now-doctor-sign-up-invalid-password": "Contraseña inválida",
  "dr-now-doctor-sign-up-passwords-must-match": "Las contraseñas deben coincidir",
  "dr-now-doctor-sign-up-service-error": "Error de servicio",
  "dr-now-doctor-sign-up-please-try-again-later": "Por favor, inténtalo de nuevo",
  "dr-now-doctor-sign-up-processing": "Procesando",
  "dr-now-doctor-sign-up-email-registered-title": "Error de registro",
  "dr-now-doctor-sign-up-email-registered-message": "El correo electrónico ya ha sido registrado",
  "register-completed": "¡Te damos la bienvenida!",
  "register-completed-message-1": "Gracias por unirte a la comunidad de Dr. Now.",
  "register-completed-message-2": "A continuación recibirás un correo electrónico con las instrucciones para acceder a nuestra plataforma.",
  "register-completed-message-3": "Estamos emocionados de que tu práctica médica sea parte de esta nueva forma de hacer medicina.",
  dashboard: "Ir al inicio",
  "go-home": "Ir a inicio",
  "valid-country-code": "Ingrese un código de país válido",
};
